// Search
export const ApiParamsChanged = 'api_params_changed' // API 请求，该事件会包含需要请求的参数
export const ApiSearching = 'searching' // API 开始请求，该事件会返回API请求的信息
export const ApiFilterDisplayRefresh = 'filter_display_refresh' // 请求重新 trigger searching 通知 filter 的内容变化了

export const ForceReloadSource = 'force-reload'
